import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const Intro = () => {
  return (
    <Box
      margin={{ xs: "35% 0% 25% 0%", sm: "10%" }}
      width={{ xs: "95%", sm: "80%" }}
    >
      <Typography
        variant="h4"
        color={"#39484E"}
        paddingBottom={{ xs: "4%", sm: "2%" }}
        textAlign={"center"}
        fontWeight={700}
      >
        The Fund harnesses Africa’s diversity of talent, creativity, and
        untapped potential to drive a continent-wide shift toward adaptability
        and self-sufficiency.
      </Typography>
      <Typography
        variant="body1"
        color={"#4f4f4f"}
        paddingBottom={{ xs: "4%", sm: "2%" }}
        paddingTop={{ xs: "5%", sm: "0%" }}
        textAlign={"center"}
      >
        The AIR Fund focuses on four strategic goals: <strong>(1)</strong>{" "}
        building climate resilience, <strong>(2)</strong> expanding economic
        opportunities, <strong>(3)</strong> supporting innovation ecosystems,
        and <strong>(4)</strong> leveraging AI for social good. By awarding
        grants of $150,000 per annum per project, the AIR Fund enables
        nonprofits, grassroots organizations, and local innovators to deliver
        targeted solutions in governance, education, healthcare, and climate
        action, thereby promoting citizen participation to drive community-led
        reforms addressing major issues such as climate change, food security,
        etc. Each project will have a fundable life-span of two years.
      </Typography>
      <Typography variant="body1" color={"#4f4f4f"} textAlign={"center"}>
        The AIR Fund prioritizes localized impact by targeting secondary cities,
        which house nearly 40% of Africa’s urban population yet receive less
        than 5% of global climate adaptation funding. AIR Fund ensures that its
        support drives meaningful change where it matters most. At AIR, we fund
        projects such as low-cost climate sensors for real-time flood
        monitoring, which have saved thousands of lives annually, and affordable
        AI-powered tools that enhance urban resilience.
      </Typography>
    </Box>
  );
};

export default Intro;
